import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { bemClassName } from 'utils/BEMHelper';

import styles from './ShareableReportSectionCellsColumn.scss';

const ShareableReportSectionCellsColumn = ({
  hidden,
  children,
  className,
  fullHeight,
  isDroppable,
  isDraggable,
}) => (
  <div className="u-inline-block">
    <div
      className={className}
      styleName={bemClassName('m-shareable-report-section-cells-column', {
        hidden,
        draggable: isDraggable,
        droppable: isDroppable,
        'full-height': fullHeight,
      })}
    >
      {children}
    </div>
  </div>
);

ShareableReportSectionCellsColumn.propTypes = {
  hidden: PropTypes.bool,
  fullHeight: PropTypes.bool,
  isDraggable: PropTypes.bool,
  isDroppable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CSSModules(ShareableReportSectionCellsColumn, styles, { allowMultiple: true });
